(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-destination"]) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '.destination-collection';

    function setActivePlan(section, planType) {
      const buttons = Array.from(section.querySelectorAll('[data-plan-button]'));
      const panels = Array.from(section.querySelectorAll('[data-plan-panel]'));

      buttons.forEach((button) => {
        const isActive = button.dataset.planType === planType;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.planType === planType;
        panel.hidden = !isActive;
      });
    }

    function setStatus(section, message, isError = false) {
      const status = section.querySelector('[data-cart-status]');
      if (!status) return;

      if (!message) {
        status.hidden = true;
        status.textContent = '';
        status.classList.remove('is-error');
        return;
      }

      status.hidden = false;
      status.textContent = message;
      status.classList.toggle('is-error', isError);

      window.clearTimeout(Number(status.dataset.statusTimeout || 0));
      const timeoutId = window.setTimeout(() => {
        status.hidden = true;
        status.textContent = '';
        status.classList.remove('is-error');
      }, 2000);

      status.dataset.statusTimeout = String(timeoutId);
    }

    async function syncCartCount() {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to refresh cart.');
      }

      const cart = await response.json();

      window.dispatchEvent(
        new CustomEvent('jettello:cart-updated', {
          detail: {
            itemCount: cart.item_count
          }
        })
      );

      return cart;
    }

    async function addToCart(section, button) {
      const variantId = button.dataset.variantId;
      const addUrl = section.dataset.cartAddUrl || '/cart/add.js';

      if (!variantId || button.disabled || button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;

      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Unable to add this plan right now.');
        }

        await response.json();
        await syncCartCount();
        setStatus(section, 'Added to cart');
      } catch (error) {
        setStatus(section, error.message || 'Unable to add this plan right now.', true);
      } finally {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }

    function initDestinationCollections(root) {
      let sections = [];

      if (root.matches && root.matches(SECTION_SELECTOR)) {
        sections = [root];
      } else if (root.querySelectorAll) {
        sections = Array.from(root.querySelectorAll(SECTION_SELECTOR));
      }

      sections.forEach((section) => {
        if (section.dataset.destinationCollectionBound === 'true') return;

        const firstButton = section.querySelector('[data-plan-button]');
        const defaultPlan = section.dataset.defaultPlan || (firstButton ? firstButton.dataset.planType : '');

        section.addEventListener('click', (event) => {
          const addToCartButton = event.target.closest('[data-add-to-cart]');
          if (addToCartButton && section.contains(addToCartButton)) {
            addToCart(section, addToCartButton);
            return;
          }

          const button = event.target.closest('[data-plan-button]');
          if (!button || !section.contains(button)) return;

          setActivePlan(section, button.dataset.planType);
        });

        section.addEventListener('keydown', (event) => {
          const activeButton = event.target.closest('[data-plan-button]');
          if (!activeButton || !section.contains(activeButton)) return;

          const buttons = Array.from(section.querySelectorAll('[data-plan-button]'));
          const currentIndex = buttons.indexOf(activeButton);

          if (currentIndex === -1) return;

          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (currentIndex + 1) % buttons.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = buttons.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          const nextButton = buttons[nextIndex];
          setActivePlan(section, nextButton.dataset.planType);
          nextButton.focus();
        });

        if (defaultPlan) {
          setActivePlan(section, defaultPlan);
        }

        section.dataset.destinationCollectionBound = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initDestinationCollections(document));
    } else {
      initDestinationCollections(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initDestinationCollections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["destination-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '.destination-grid';

    function setActiveGroup(section, group) {
      const tabs = Array.from(section.querySelectorAll('[data-destination-tab]'));
      const cards = Array.from(section.querySelectorAll('[data-destination-card]'));

      if (!tabs.length || !cards.length) return;

      tabs.forEach((tab) => {
        const isActive = tab.dataset.group === group;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      cards.forEach((card) => {
        const matches = card.dataset.group === group;
        card.hidden = !matches;
      });
    }

    function initDestinationGrid(root) {
      let sections = [];

      if (root.matches && root.matches(SECTION_SELECTOR)) {
        sections = [root];
      } else if (root.querySelectorAll) {
        sections = Array.from(root.querySelectorAll(SECTION_SELECTOR));
      }

      sections.forEach((section) => {
        if (section.dataset.destinationGridBound === 'true') return;

        section.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-destination-tab]');
          if (!tab || !section.contains(tab)) return;

          setActiveGroup(section, tab.dataset.group);
        });

        setActiveGroup(section, section.dataset.defaultGroup || 'europe');
        section.dataset.destinationGridBound = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initDestinationGrid(document));
    } else {
      initDestinationGrid(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initDestinationGrid(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-footer-section]';

    function getSections(root) {
      if (root.matches && root.matches(SECTION_SELECTOR)) return [root];
      if (!root.querySelectorAll) return [];

      return Array.from(root.querySelectorAll(SECTION_SELECTOR));
    }

    function closeDisclosures(section, keepOpenMenu) {
      const buttons = Array.from(section.querySelectorAll('[data-header-disclosure-button]'));
      const menus = Array.from(section.querySelectorAll('[data-header-disclosure-menu]'));

      buttons.forEach((button) => {
        const controls = button.getAttribute('aria-controls');
        const shouldStayOpen = keepOpenMenu && controls === keepOpenMenu.id;
        button.setAttribute('aria-expanded', shouldStayOpen ? 'true' : 'false');
      });

      menus.forEach((menu) => {
        if (keepOpenMenu && keepOpenMenu === menu) {
          menu.hidden = false;
        } else {
          menu.hidden = true;
        }
      });
    }

    function initFooter(section) {
      if (section.dataset.footerBound === 'true') return;

      section.addEventListener('click', (event) => {
        const disclosureButton = event.target.closest('[data-header-disclosure-button]');
        if (!disclosureButton || !section.contains(disclosureButton)) return;

        const menuId = disclosureButton.getAttribute('aria-controls');
        const menu = menuId ? section.querySelector(`#${menuId}`) : null;
        if (!menu) return;

        const shouldOpen = menu.hidden;
        closeDisclosures(section, shouldOpen ? menu : null);
      });

      section.dataset.footerBound = 'true';
    }

    if (!window.__siteFooterGlobalBound) {
      document.addEventListener('click', (event) => {
        getSections(document).forEach((section) => {
          if (!section.contains(event.target)) {
            closeDisclosures(section);
          }
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        getSections(document).forEach((section) => {
          closeDisclosures(section);
        });
      });

      window.__siteFooterGlobalBound = true;
    }

    function init(root) {
      getSections(root).forEach((section) => initFooter(section));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-header-section]';

    function getSections(root) {
      if (root.matches && root.matches(SECTION_SELECTOR)) return [root];
      if (!root.querySelectorAll) return [];

      return Array.from(root.querySelectorAll(SECTION_SELECTOR));
    }

    function closeDisclosures(section, keepOpenMenu) {
      const buttons = Array.from(section.querySelectorAll('[data-header-disclosure-button]'));
      const menus = Array.from(section.querySelectorAll('[data-header-disclosure-menu]'));

      buttons.forEach((button) => {
        const controls = button.getAttribute('aria-controls');
        const shouldStayOpen = keepOpenMenu && controls === keepOpenMenu.id;
        button.setAttribute('aria-expanded', shouldStayOpen ? 'true' : 'false');
      });

      menus.forEach((menu) => {
        if (keepOpenMenu && keepOpenMenu === menu) {
          menu.hidden = false;
        } else {
          menu.hidden = true;
        }
      });
    }

    function openMobileMenu(section) {
      const toggle = section.querySelector('[data-header-toggle]');
      const overlay = section.querySelector('[data-header-overlay]');
      const panel = section.querySelector('[data-header-panel]');

      if (!toggle || !overlay || !panel) return;

      toggle.setAttribute('aria-expanded', 'true');
      overlay.hidden = false;
      panel.hidden = false;
      document.body.dataset.headerOverflow = document.body.style.overflow || '';
      document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu(section) {
      const toggle = section.querySelector('[data-header-toggle]');
      const overlay = section.querySelector('[data-header-overlay]');
      const panel = section.querySelector('[data-header-panel]');

      if (!toggle || !overlay || !panel) return;

      toggle.setAttribute('aria-expanded', 'false');
      overlay.hidden = true;
      panel.hidden = true;

      if (document.body.dataset.headerOverflow != null) {
        document.body.style.overflow = document.body.dataset.headerOverflow;
      } else {
        document.body.style.overflow = '';
      }
    }

    function initHeader(section) {
      if (section.dataset.headerBound === 'true') return;

      section.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-header-toggle]');
        if (toggle && section.contains(toggle)) {
          const isExpanded = toggle.getAttribute('aria-expanded') == 'true';

          if (isExpanded) {
            closeMobileMenu(section);
          } else {
            openMobileMenu(section);
          }

          return;
        }

        const closeButton = event.target.closest('[data-header-close]');
        if (closeButton && section.contains(closeButton)) {
          closeMobileMenu(section);
          return;
        }

        const disclosureButton = event.target.closest('[data-header-disclosure-button]');
        if (!disclosureButton || !section.contains(disclosureButton)) return;

        const menuId = disclosureButton.getAttribute('aria-controls');
        const menu = menuId ? section.querySelector(`#${menuId}`) : null;
        if (!menu) return;

        const shouldOpen = menu.hidden;
        closeDisclosures(section, shouldOpen ? menu : null);
      });

      section.dataset.headerBound = 'true';
    }

    function updateCartCount(itemCount) {
      const count = Number(itemCount) || 0;

      document.querySelectorAll('[data-header-cart-count]').forEach((badge) => {
        badge.textContent = String(count);
        badge.classList.toggle('is-hidden', count === 0);
      });

      document.querySelectorAll('[data-header-cart-link]').forEach((link) => {
        link.setAttribute('aria-label', count > 0 ? `Cart (${count} items)` : 'Cart');
      });
    }

    if (!window.__siteHeaderGlobalBound) {
      document.addEventListener('click', (event) => {
        getSections(document).forEach((section) => {
          if (!section.contains(event.target)) {
            closeDisclosures(section);
          }
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        getSections(document).forEach((section) => {
          closeDisclosures(section);
          closeMobileMenu(section);
        });
      });

      window.addEventListener('jettello:cart-updated', (event) => {
        const itemCount = event.detail && typeof event.detail.itemCount !== 'undefined' ? event.detail.itemCount : 0;
        updateCartCount(itemCount);
      });

      window.__siteHeaderGlobalBound = true;
    }

    function init(root) {
      getSections(root).forEach((section) => initHeader(section));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-esim-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    const debounce = (callback, delay) => {
      let timeoutId;

      return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => callback(...args), delay);
      };
    };

    const normalizeText = (value) => value.trim().toLowerCase();

    const handleize = (value) =>
      value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const buildSuggestionsUrl = (query) => {
      const url = new URL(`${rootPath}search/suggest.json`, window.location.origin);

      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'collection');
      url.searchParams.set('resources[limit]', '8');

      return url;
    };

    const buildCollectionUrl = (handle) => {
      const normalizedRootPath = rootPath.endsWith('/') ? rootPath : `${rootPath}/`;

      return new URL(`collections/${handle}`, window.location.origin + normalizedRootPath).toString();
    };

    const findExactCollectionMatch = (query, collections) => {
      const normalizedQuery = normalizeText(query);
      const handleizedQuery = handleize(query);

      return collections.find((collection) => {
        const collectionTitle = normalizeText(collection.title || '');
        const collectionHandle = normalizeText(collection.handle || '');

        return collectionTitle === normalizedQuery || collectionHandle === handleizedQuery;
      });
    };

    const initializeHeroEsimSearch = (sectionElement) => {
      const searchCard = sectionElement.querySelector('.hero-esim-search__search-card');

      if (!searchCard || searchCard.dataset.heroEsimSearchInitialized === 'true') {
        return;
      }

      const form = searchCard.querySelector('.hero-esim-search__search-form');
      const input = form && form.querySelector('.hero-esim-search__input');
      const suggestions = searchCard.querySelector('.hero-esim-search__suggestions');
      const errorMessage = searchCard.querySelector('.hero-esim-search__error');
      const destinationButtons = searchCard.querySelectorAll('[data-destination-query]');
      const noMatchMessage = searchCard.dataset.noMatchMessage || 'Currently we don\'t support this country';

      let activeSuggestionIndex = -1;
      let latestCollections = [];
      let latestQuery = '';
      let pendingRequestController;

      if (!form || !input || !suggestions) {
        return;
      }

      const hideError = () => {
        errorMessage.hidden = true;
        errorMessage.textContent = '';
      };

      const showError = (message) => {
        errorMessage.textContent = message;
        errorMessage.hidden = false;
      };

      const setSuggestionsVisibility = (isVisible) => {
        suggestions.hidden = !isVisible;
        input.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
      };

      const renderSuggestions = (collections) => {
        latestCollections = collections;
        activeSuggestionIndex = -1;

        if (collections.length === 0) {
          suggestions.innerHTML = '';
          setSuggestionsVisibility(false);
          return;
        }

        suggestions.replaceChildren();

        collections.forEach((collection, index) => {
          const button = document.createElement('button');
          button.className = 'hero-esim-search__suggestion';
          button.type = 'button';
          button.setAttribute('role', 'option');
          button.dataset.suggestionIndex = String(index);
          button.setAttribute('aria-selected', 'false');
          button.textContent = collection.title || '';
          suggestions.append(button);
        });

        setSuggestionsVisibility(true);
      };

      const updateActiveSuggestion = (nextIndex) => {
        const suggestionButtons = suggestions.querySelectorAll('.hero-esim-search__suggestion');

        suggestionButtons.forEach((button, index) => {
          const isActive = index === nextIndex;
          button.classList.toggle('hero-esim-search__suggestion--active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        activeSuggestionIndex = nextIndex;
      };

      const redirectToCollection = (collection) => {
        if (!collection || !collection.handle) {
          showError(noMatchMessage);
          return;
        }

        window.location.assign(buildCollectionUrl(collection.handle));
      };

      const resolveCollectionFromQuery = async (query) => {
        const collections = await fetchCollections(query);
        const exactMatch = findExactCollectionMatch(query, collections);

        if (exactMatch) {
          return exactMatch;
        }

        const handle = handleize(query);

        if (handle === '') {
          return null;
        }

        const response = await fetch(buildCollectionUrl(handle), {
          method: 'GET',
          headers: {
            Accept: 'text/html'
          }
        });

        if (!response.ok) {
          return null;
        }

        return {
          handle,
          title: query.trim()
        };
      };

      const fetchCollections = async (query) => {
        const trimmedQuery = query.trim();

        if (trimmedQuery === '') {
          latestQuery = '';
          latestCollections = [];
          renderSuggestions([]);
          return [];
        }

        if (trimmedQuery === latestQuery && latestCollections.length > 0) {
          return latestCollections;
        }

        if (pendingRequestController) {
          pendingRequestController.abort();
        }

        pendingRequestController = new AbortController();

        try {
          const response = await fetch(buildSuggestionsUrl(trimmedQuery), {
            signal: pendingRequestController.signal,
            headers: {
              Accept: 'application/json'
            }
          });

          if (!response.ok) {
            throw new Error(`Predictive search failed with status ${response.status}`);
          }

          const data = await response.json();
          const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

          latestQuery = trimmedQuery;
          renderSuggestions(collections);

          return collections;
        } catch (error) {
          if (error.name === 'AbortError') {
            return latestCollections;
          }

          renderSuggestions([]);
          throw error;
        }
      };

      const debouncedFetchCollections = debounce(async () => {
        hideError();

        try {
          await fetchCollections(input.value);
        } catch (error) {
          console.error(error);
        }
      }, 180);

      const submitSearch = async (query) => {
        const trimmedQuery = query.trim();

        hideError();

        if (trimmedQuery === '') {
          renderSuggestions([]);
          return;
        }

        try {
          const exactMatch = await resolveCollectionFromQuery(trimmedQuery);

          if (exactMatch) {
            redirectToCollection(exactMatch);
            return;
          }

          showError(noMatchMessage);
        } catch (error) {
          console.error(error);
          showError(noMatchMessage);
        }
      };

      input.addEventListener('input', () => {
        debouncedFetchCollections();
      });

      input.addEventListener('keydown', (event) => {
        const suggestionButtons = suggestions.querySelectorAll('.hero-esim-search__suggestion');

        if (event.key == 'Escape') {
          setSuggestionsVisibility(false);
          return;
        }

        if (suggestionButtons.length === 0) {
          return;
        }

        if (event.key == 'ArrowDown') {
          event.preventDefault();
          const nextIndex = activeSuggestionIndex + 1 >= suggestionButtons.length ? 0 : activeSuggestionIndex + 1;
          updateActiveSuggestion(nextIndex);
          suggestionButtons[nextIndex].focus();
        }

        if (event.key == 'ArrowUp') {
          event.preventDefault();
          const nextIndex = activeSuggestionIndex <= 0 ? suggestionButtons.length - 1 : activeSuggestionIndex - 1;
          updateActiveSuggestion(nextIndex);
          suggestionButtons[nextIndex].focus();
        }
      });

      input.addEventListener('focus', () => {
        if (latestCollections.length > 0) {
          setSuggestionsVisibility(true);
        }
      });

      input.addEventListener('blur', () => {
        window.setTimeout(() => {
          if (!searchCard.contains(document.activeElement)) {
            setSuggestionsVisibility(false);
          }
        }, 120);
      });

      suggestions.addEventListener('click', (event) => {
        const suggestionButton = event.target.closest('[data-suggestion-index]');

        if (!suggestionButton) {
          return;
        }

        const collection = latestCollections[Number(suggestionButton.dataset.suggestionIndex)];

        if (!collection) {
          return;
        }

        input.value = collection.title || '';
        redirectToCollection(collection);
      });

      suggestions.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!searchCard.contains(document.activeElement)) {
            setSuggestionsVisibility(false);
          }
        }, 120);
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitSearch(input.value);
      });

      destinationButtons.forEach((button) => {
        button.addEventListener('click', () => {
          input.value = button.dataset.destinationQuery || '';
          submitSearch(input.value);
        });
      });

      searchCard.dataset.heroEsimSearchInitialized = 'true';
    };

    const initializeAllHeroEsimSearchSections = (root = document) => {
      root.querySelectorAll('.hero-esim-search').forEach(initializeHeroEsimSearch);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllHeroEsimSearchSections(), { once: true });
    } else {
      initializeAllHeroEsimSearchSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllHeroEsimSearchSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installation-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getSections = (root) => root.querySelectorAll('.installation-steps');

    const closeDialog = (dialog) => {
      if (dialog && dialog.open) {
        dialog.close();
      }
    };

    const initInstallationSteps = (section) => {
      if (!section || section.dataset.installationStepsInitialized === 'true') {
        return;
      }

      const triggers = section.querySelectorAll('[data-installation-modal-trigger]');
      const dialogs = section.querySelectorAll('[data-installation-dialog]');

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const dialogId = trigger.getAttribute('data-installation-modal-trigger');
          const dialog = dialogId ? section.querySelector(`#${CSS.escape(dialogId)}`) : null;

          if (!dialog) {
            return;
          }

          dialog.showModal();
        });
      });

      dialogs.forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          const bounds = dialog.getBoundingClientRect();
          const clickedBackdrop =
            event.clientX < bounds.left ||
            event.clientX > bounds.right ||
            event.clientY < bounds.top ||
            event.clientY > bounds.bottom;

          if (clickedBackdrop) {
            closeDialog(dialog);
          }
        });

        dialog.querySelectorAll('[data-installation-modal-close]').forEach((button) => {
          button.addEventListener('click', () => {
            closeDialog(dialog);
          });
        });
      });

      section.dataset.installationStepsInitialized = 'true';
    };

    const init = (root = document) => {
      getSections(root).forEach(initInstallationSteps);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
